<template>
  <svg viewBox="0 0 64 64">
    <svg>
      <svg id="bejaard">
        <path
          d="M36.8,1.7c2.1,0,3.9,1.5,4.3,3.5h-0.3c0-0.4-0.4-0.7-0.8-0.7h-2.2c-0.4,0-0.7,0.3-0.8,0.7h-0.6
                        c0-0.4-0.4-0.7-0.8-0.7h-2.2c-0.4,0-0.7,0.3-0.8,0.7h-0.3C32.9,3.2,34.7,1.7,36.8,1.7 M36.8,10.5c-2.2,0-4-1.6-4.3-3.6h0.4
                        c0.2,0.8,0.9,1.4,1.8,1.4c0.9,0,1.6-0.6,1.8-1.4h0.7c0.2,0.8,0.9,1.4,1.8,1.4s1.6-0.6,1.8-1.4h0.4C40.8,8.9,39,10.5,36.8,10.5
                         M36.8,12.1c3.3,0,6.1-2.7,6.1-6.1c0-3.3-2.7-6.1-6.1-6.1s-6.1,2.7-6.1,6.1C30.7,9.4,33.5,12.1,36.8,12.1"
        />
        <path
          d="M39.8,61.5h-2.1V42.8h1.8v-1.7h-5.2v1.7h1.8v18.7h-2.2L31,37.7h5.8l5.8,0L39.8,61.5z M30.9,21.6
                        c0-2.3,2.7-5,5.9-5c3.1,0,5.7,2.6,5.9,4.8v14.7l-11.8,0V21.6z M44.4,21.6c0-3.1-3.3-6.7-7.5-6.7c-4.2,0-7.5,3.6-7.5,6.7v16.2h0.1
                        l3,25.4h8.9l3-25.4h0.1L44.4,21.6z"
        />
        <path
          d="M24.5,32.4c-1.8,0-3.2,1.4-3.2,3.2c0,1.5,1,2.7,2.4,3.1v24.8h1.7V38.6c1.4-0.4,2.4-1.6,2.4-3.1
                        C27.7,33.8,26.3,32.4,24.5,32.4"
        />
      </svg>
    </svg>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconBejaard extends Vue {}
</script>
